const QuestionEncounter = () => {
    return(
        <div className="w-full h-full text-6xl flex justify-center items-center mt-10">施工中</div>
    )
}

export default QuestionEncounter;